export default {"src":"/_next/static/media/hero.ec3c8881.svg","height":420,"width":620,"blurWidth":0,"blurHeight":0};